function importAll(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
}

const images = importAll(require.context('./images', true, /\.(png|jpe?g|svg|gif|ico)$/));

export default images;